import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { Loader } from 'ui';
import { ViewPeerGroup } from 'modules/common';
import { useReportPage } from 'shared/hooks';
import { fetchPeersNames } from 'services';
import { RankingItem } from './RankingItem';

const useStyles = makeStyles(theme => ({
  divider: {
    alignSelf: 'stretch',
    height: 'auto',
    margin: theme.spacing(0, 2),
  },
}));

const ESGRanking = ({ data, loading, id, entityName }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { totalRank, totalSection, environmentSection, socialSection, governanceSection } = data;

  return (
    <Paper>
      <Box px={2} pt={1}>
        <Grid container>
          <Grid item xs={10}>
            <Typography variant="h6">{t('Ranking compared to peers')}</Typography>
          </Grid>
          {!useReportPage ? (
            <Grid container item xs={2} justifyContent="flex-end">
              <ViewPeerGroup id={id} fetchPeersNames={fetchPeersNames} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <Box p={2} py={useReportPage ? 1 : 2}>
        {loading ? (
          <Loader center />
        ) : (
          <>
            <Box pb={2}>
              <Divider />
            </Box>
            <Grid container justifyContent="space-around">
              <RankingItem
                title={t('Total')}
                section={totalSection}
                total={totalRank}
                entityName={entityName}
              />
              <Divider className={classes.divider} orientation="vertical" />
              <RankingItem
                title={t('Environment')}
                section={environmentSection}
                total={totalRank}
                entityName={entityName}
              />
              <Divider className={classes.divider} orientation="vertical" />
              <RankingItem
                title={t('Social')}
                section={socialSection}
                total={totalRank}
                entityName={entityName}
              />
              <Divider className={classes.divider} orientation="vertical" />
              <RankingItem
                title={t('Governance')}
                section={governanceSection}
                total={totalRank}
                entityName={entityName}
              />
            </Grid>
          </>
        )}
      </Box>
    </Paper>
  );
};

ESGRanking.propTypes = {
  loading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  entityName: PropTypes.string.isRequired,
  data: PropTypes.shape({
    totalRank: PropTypes.number.isRequired,
    totalSection: PropTypes.object.isRequired,
    environmentSection: PropTypes.object.isRequired,
    socialSection: PropTypes.object.isRequired,
    governanceSection: PropTypes.object.isRequired,
  }).isRequired,
};

export default ESGRanking;
